export function GetMockCaseRead() {
  return {
    id: 1862,
    caseRef: "SAG1242",
    referredById: 314,
    caseStatusId: 26,
    developmentId: 39,
    purchasePrice: 410000,
    plotNumber: "43",
    htb: 0,
    cashBuyer: 0,
    so: 1,
    keyNotes:
      "You may pronounce name like: 'Mr. Shu'\nBluenote - Hayes\n2 bedroom\nShared Ownership\nIncome: £25k\nDeposit: £20k-£30k\nFTB",
    dateOfReferral: "2022-08-22T08:24:33.3040773",
    offerExpiryDate: "0001-01-01T00:00:00",
    updatedDate: "2022-11-01T15:34:07.6722629",
    isDeleted: 0,
    advisorId: 4,
    propertyStatusId: 40,
    depositLevel: 30000,
    serviceCharge: 149.64,
    minPercShareAvailable: "25",
    housingAssociation: "Sage",
    financialDetailsId: null,
    closedDate: "0001-01-01T00:00:00",
    isClosed: 0,
    administratorId: null,
    lnhManagerId: 108,
  };
}
